// src/pages/Register.tsx
import React, { useState } from 'react';
import {
  Box,
  Button,
  Input,
  FormControl,
  FormLabel,
  Heading,
  useToast,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const Register: React.FC = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmacaoSenha, setConfirmacaoSenha] = useState('');
  const [loading, setLoading] = useState(false);

  const toast = useToast();
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    if (senha !== confirmacaoSenha) {
      toast({
        title: 'Erro no cadastro',
        description: 'A confirmação da senha não confere.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${config.apiUrl}/auth/register`, {
        nome,
        email,
        senha,
      });

      toast({
        title: 'Cadastro realizado',
        description: 'Usuário cadastrado com sucesso.',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });

      navigate('/login');
    } catch (error: any) {
      console.error(error);

      toast({
        title: 'Erro no cadastro',
        description:
          error?.response?.data?.message || 'Não foi possível realizar o cadastro.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      maxW="md"
      mx="auto"
      mt={8}
      p={4}
      borderWidth={1}
      borderRadius="lg"
      boxShadow="lg"
      bg="secondary"
      color="text"
    >
      <Heading mb={6} textAlign="center" color="primary">
        Cadastro
      </Heading>

      <form onSubmit={handleRegister}>
        <FormControl mb={4}>
          <FormLabel>Nome</FormLabel>
          <Input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Digite seu nome"
            required
            border="1px solid black"
          />
        </FormControl>

        <FormControl mb={4}>
          <FormLabel>Email</FormLabel>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Digite seu email"
            required
            border="1px solid black"
          />
        </FormControl>

        <FormControl mb={4}>
          <FormLabel>Senha</FormLabel>
          <Input
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Digite sua senha"
            required
            border="1px solid black"
          />
        </FormControl>

        <FormControl mb={4}>
          <FormLabel>Confirmar senha</FormLabel>
          <Input
            type="password"
            value={confirmacaoSenha}
            onChange={(e) => setConfirmacaoSenha(e.target.value)}
            placeholder="Confirme sua senha"
            required
            border="1px solid black"
          />
        </FormControl>

        <Button
          type="submit"
          isLoading={loading}
          bg="primary"
          color="white"
          _hover={{ bg: 'accent' }}
          width="100%"
          mb={4}
        >
          Cadastrar
        </Button>
      </form>

      <Text textAlign="center">
        Já possui conta?{' '}
        <Text as={RouterLink} to="/login" color="primary" fontWeight="bold">
          Entrar
        </Text>
      </Text>
    </Box>
  );
};

export default Register;